// Section for import npm components -----------------------------------------------------------------------------------
import React, { useState } from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Section for import custom components --------------------------------------------------------------------------------
// import { AppConfigContext } from '@providers/AppConfigProvider';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { styled } from '@mui/material/styles';

// Section for type definition -----------------------------------------------------------------------------------------

// アイコンの色をカスタマイズ
const CustomArrowDropDownIcon = styled(ArrowDropDownIcon)({
  fill: '#119CDA',
});

interface SquareMetersSelectorProps {
  onSquareMeterChange: (squareMeter: string) => void;
}

export default function SquareMetersSelector({ onSquareMeterChange }: SquareMetersSelectorProps) {
  const [squareMeter, setSquareMeter] = useState('70');
  const handleChange = (event: SelectChangeEvent) => {
    const newSquareMeter = event.target.value;
    setSquareMeter(newSquareMeter);
    onSquareMeterChange(newSquareMeter);
  };

  return (
    <Box className="max-md:ml-5 mb-7 max-md:mb-6">
      <Box className="flex gap-x-3 max-md:gap-x-2">
        <Box className="w-[136px] max-md:w-[100px] h-14 max-md:h-[40px]">
          <FormControl
            fullWidth
            sx={{
              '& .MuiSelect-select': {
                padding: '16.5px 14px',
                fontSize: '16px',
                '@media (max-width: 767px)': {
                  padding: '8.5px 14px',
                  fontSize: '14px',
                },
              },
            }}
          >
            <InputLabel id="simple-select-label">平米数</InputLabel>

            <Select
              labelId="simple-select-label"
              id="simple-select"
              value={squareMeter}
              label="squareMeter"
              onChange={handleChange}
              IconComponent={CustomArrowDropDownIcon}
            >
              {Array.from({ length: 29 }, (_, index) => (index + 2) * 10).map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Typography className="text-sm max-md:text-xs leading-[56px] max-md:leading-10">
          ㎡換算の相場情報が表示されています
        </Typography>
      </Box>
    </Box>
  );
}
